import React, { useState, useContext } from "react";
import { useMutation } from "@tanstack/react-query";

//App
import { FormContainerProps } from "../../types";
import UserPermissionsForm from "./UserPermissionsForm";
import userClaimApi from "../../app/model/api/userClaimApi";
import { UsersContext } from "./UsersContainer";
import { UserClaimDto } from "../../app/model/api/types/dto";
import { apiErrorMessage } from "../../utility/lib/error";
import { Snackbar } from "../common/VFX-UI";
import { UserClaimsViewModel } from "../../viewModels";
import { EMPTY_GUID } from "../../utility/constants/constants";

interface SnackbarState {
    showErrorSnackbar: boolean;
    errorMessage: string;
}

export const UserPermissionsFormContainer = (props: FormContainerProps) => {
    const { onClose, onShowSuccess } = props;
    const userContext = useContext(UsersContext);
    const successMessage =  "User Permissions updated";

    const [snackbar, setSnackbar] = useState<SnackbarState>({
        showErrorSnackbar: false,
        errorMessage: "",
    });

    const onShowErrorSnackbar = (errorMessage: string) => {
        setSnackbar({
            showErrorSnackbar: true,
            errorMessage,
        });
    };

    const onCloseSnackbar = () => {
        setSnackbar({
            showErrorSnackbar: false,
            errorMessage: "",
        });
    };

    const { status, mutate } = useMutation<void, Error, UserClaimDto>({
        mutationFn: async (payload: UserClaimDto) => {
            const response = await userClaimApi.save(payload);
            const errorMessage = apiErrorMessage(response.errorMessages);
            onClose();
            if (errorMessage) {
                onShowErrorSnackbar(errorMessage);
            } else {
                onShowSuccess(successMessage);
            }
        },
    });

    const handleOnSubmitHandler = async (values: UserClaimDto) => {
        if (values.userId == null) values.userId = EMPTY_GUID;
        mutate(values);
    };

    const initialVal = userContext?.id ? new UserClaimsViewModel(
        userContext?.id ?? EMPTY_GUID,
        userContext?.usersPermissionsData?.claims ?? [],
    ) :
        new UserClaimsViewModel(
             EMPTY_GUID,
             [],
        ) 
    ;

  return (
      <>
          <UserPermissionsForm onClose={onClose} initialVal={initialVal} handleOnSubmit={handleOnSubmitHandler} status={status } />
          {snackbar.showErrorSnackbar && (
              <Snackbar
                  open={true}
                  message={snackbar.errorMessage}
                  handleClose={onCloseSnackbar}
                  severity="danger"
              />
          )}
    </>
  );
};
